/** Default radius when the user has set a delivery location. */
export const DEFAULT_DISTANCE_MI = 10;

export const MI_TO_KM = 1.609344;

export function normalizeCoords(value) {
  if (!value || typeof value !== 'object') return null;
  const latitude = value.latitude ?? value.lat;
  const longitude = value.longitude ?? value.lng ?? value.lon;
  if (latitude == null || longitude == null) return null;
  const latNum = Number(latitude);
  const lngNum = Number(longitude);
  if (!Number.isFinite(latNum) || !Number.isFinite(lngNum)) return null;
  return { latitude: latNum, longitude: lngNum };
}

export function milesToKmString(miles) {
  const mi = Number(miles);
  if (!Number.isFinite(mi) || mi <= 0) return null;
  return (mi * MI_TO_KM).toFixed(2);
}
